import type {
  DiagnosticChecklist,
  DiagnosticChecklistItem,
  DiagnosticFinding,
} from "./types";

export function buildDiagnosticChecklist(
  findings: readonly DiagnosticFinding[],
): DiagnosticChecklist {
  const items: DiagnosticChecklistItem[] = findings.map((finding) => {
    const blocked = finding.confidence === "unknown";

    return {
      id: `check-${finding.id}`,
      findingId: finding.id,
      title: finding.title,
      status: blocked ? "blocked" : "ready",
      severity: finding.severity,
      evidence: [...finding.evidence],
      action: finding.recommendedAction,
      requiresApproval: finding.requiresMutation,
      requiresMutation: finding.requiresMutation,
      dependencies: [],
    };
  });

  return {
    items,
    readyCount: items.filter((item) => item.status === "ready").length,
    blockedCount: items.filter((item) => item.status === "blocked").length,
    pendingCount: items.filter((item) => item.status === "pending").length,
  };
}
